module.exports = __webpack_public_path__ + "img/appraise.5415288c.png";